function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';

var Toolbar = function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Toolbar.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Toolbar.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        style = _props.style;
    return React.createElement('div', {
      id: id,
      className: 'textoUsuario',
      style: style
    }, React.createElement('button', {
      className: 'ql-bold'
    }), React.createElement('button', {
      className: 'ql-italic'
    }), React.createElement('button', {
      className: 'ql-underline'
    }), React.createElement('select', {
      className: 'ql-color',
      defaultValue: '#d0d1d2'
    }, React.createElement('option', {
      value: 'black'
    }), React.createElement('option', {
      value: 'red'
    }), React.createElement('option', {
      value: 'green'
    }), React.createElement('option', {
      value: 'blue'
    }), React.createElement('option', {
      value: 'orange'
    }), React.createElement('option', {
      value: 'violet'
    }), React.createElement('option', {
      value: '#d0d1d2'
    }), React.createElement('option', {
      value: 'white'
    })), React.createElement('select', {
      className: 'ql-size',
      defaultValue: '1em'
    }, React.createElement('option', {
      value: '0.6em'
    }, 'small'), React.createElement('option', {
      value: '1em'
    }, 'normal'), React.createElement('option', {
      value: '1.5em'
    }, 'large'), React.createElement('option', {
      value: '3em'
    }, 'huge')), React.createElement('button', {
      className: 'ql-cerrar'
    }, React.createElement('svg', {
      viewBox: '0 0 18 18'
    }, React.createElement('path', {
      className: 'ql-fill',
      fill: '#445464',
      d: 'M12.631,9.543c0.962,0.779,2.102,1.604,2.362,1.847c0.817,0.761,0.654,1.692,0.287,2.171c-0.367,0.479-0.496,0.561-0.988,0.985c-0.604,0.521-1.545,0.501-2.22-0.117c-0.41-0.376-1.279-1.166-1.798-1.665c-0.818-0.785-1.505-0.973-2.418-0.178c-0.459,0.4-1.452,1.084-2.159,1.759c-0.949,0.905-1.77,0.542-2.23,0.105c-0.525-0.499-0.334-0.267-0.686-0.67c-0.352-0.403-0.637-1.363,0.081-2.125c0.274-0.291,1.41-1.164,2.402-2.108c0.344-0.327,0.469-0.781,0.041-1.174C4.483,7.616,3.329,6.641,3.007,6.34C2.19,5.579,2.353,4.649,2.719,4.169s0.496-0.561,0.988-0.985c0.604-0.521,1.545-0.501,2.22,0.117c0.41,0.376,1.279,1.166,1.798,1.665c0.818,0.785,1.505,0.973,2.418,0.178c0.459-0.4,1.452-1.084,2.159-1.759c0.949-0.905,1.77-0.542,2.23-0.105c0.525,0.499,0.334,0.267,0.686,0.67c0.352,0.403,0.637,1.363-0.081,2.125c-0.35,0.372-1.613,1.526-2.506,2.351C12.156,8.865,12.401,9.357,12.631,9.543z'
    }))), React.createElement('button', {
      className: 'ql-guardar'
    }, React.createElement('svg', {
      viewBox: '0 0 18 18'
    }, React.createElement('path', {
      className: 'ql-fill',
      fill: '#445464',
      d: 'M3.862,6.723C4.272,7.099,5.35,8.091,5.87,8.59c0.818,0.785,1.505,0.973,2.418,0.178c0.459-0.4,5.452-5.084,6.159-5.759c0.949-0.905,1.77-0.542,2.23-0.105c0.525,0.499,0.334,0.267,0.686,0.67S18,4.938,17.282,5.7c-0.448,0.476-7.34,6.888-8.043,7.521c-1.26,1.134-3.052,1.196-4.438-0.017c-0.621-0.544-3.438-3.05-3.859-3.442C0.125,9,0.288,8.07,0.654,7.591S1.15,7.03,1.642,6.605C2.246,6.085,3.188,6.104,3.862,6.723z'
    }))));
  };

  return Toolbar;
}(Component);

Toolbar.propTypes = process.env.NODE_ENV !== "production" ? {
  id: t.string,
  style: t.object
} : {};
export default Toolbar;